/* LUZ NOVA — PLP AJAX filtering/sorting/pagination.
   Replaces the full-page-reload behaviour of the collection page's facet
   form, sort select and pagination links with an in-place fetch + swap of
   #CollectionResults (grid + active-filter pills + pagination nav), using
   history.pushState so the URL, back/forward and reload all still work.

   Deliberately out of scope: the Gender/Category/Style facets, which
   navigate to a DIFFERENT collection entirely (see sections/main-collection
   .liquid) rather than adding a filter param to this one — those stay full
   navigations, same as clicking any other link to another page.

   #ProductCount and the #SortBy <select> live OUTSIDE #CollectionResults on
   purpose: replacing the Sort select's DOM node would destroy the change
   listener global.js already bound to it, so this module updates its
   .value in place instead and lets that existing listener keep working.

   assets/global.js exposes window.LuzFacetSync = { restoreFromUrl,
   refreshActivePills } — re-run after every swap so the facet form's own
   checkboxes/price inputs and the active-pills row stay in sync with
   whatever URL is now current (most importantly on browser back/forward,
   where the URL changes without any form control being touched). */
(function () {
  "use strict";

  var results = document.getElementById("CollectionResults");
  var countEl = document.getElementById("ProductCount");
  var sortSelect = document.getElementById("SortBy");
  if (!results) return;

  var inFlightController = null;

  function setLoading(isLoading) {
    results.classList.toggle("is-loading", isLoading);
  }

  function swapFrom(doc, url) {
    var newResults = doc.getElementById("CollectionResults");
    if (!newResults) {
      // Fetched markup didn't contain the expected region (unexpected
      // response, e.g. a redirect to a login/interstitial page) — fail
      // safe with a real navigation rather than showing a blank grid.
      window.location.href = url;
      return;
    }
    results.innerHTML = newResults.innerHTML;

    var newCount = doc.getElementById("ProductCount");
    if (countEl && newCount) countEl.textContent = newCount.textContent;

    if (sortSelect) {
      var newSort = doc.getElementById("SortBy");
      if (newSort) sortSelect.value = newSort.value;
    }

    if (doc.title) document.title = doc.title;

    if (window.LuzFacetSync) {
      window.LuzFacetSync.restoreFromUrl();
      window.LuzFacetSync.refreshActivePills();
    }

    results.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function fetchAndSwap(url, pushHistory) {
    if (inFlightController) inFlightController.abort();
    var controller = new AbortController();
    inFlightController = controller;
    setLoading(true);

    fetch(url, { signal: controller.signal, headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) {
        if (!r.ok) throw new Error("Request failed: " + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        if (pushHistory) history.pushState({ luzAjaxFacets: true }, "", url);
        swapFrom(doc, url);
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        window.location.href = url;
      })
      .finally(function () {
        if (inFlightController === controller) {
          inFlightController = null;
          setLoading(false);
        }
      });
  }

  function navigate(url) {
    fetchAndSwap(url, true);
  }

  function submit() {
    var form = document.getElementById("FacetForm");
    if (!form) return;
    // NOTE: `[].slice.call(new FormData(form))` looks like it should work
    // (the classic array-like-to-array trick) but does NOT: FormData has no
    // `.length`, only an iterator, so `.slice.call` on it silently returns an
    // empty array rather than throwing — every filter submission would go
    // out with zero params. Array.from (or a spread) uses the iterator
    // protocol instead and picks up every field, checked box included.
    var params = new URLSearchParams(Array.from(new FormData(form)));
    var qs = params.toString();
    navigate(window.location.pathname + (qs ? "?" + qs : ""));
  }

  // Intercept same-origin links that live inside the AJAX-swapped region:
  // pagination, active-facet pill removals, "Clear all", and the
  // no-results "Clear filters" link. Everything else on the page (header
  // nav, Gender/Category/Style facets, footer, etc.) is untouched — those
  // are meant to be full navigations to a different collection/page.
  results.addEventListener("click", function (e) {
    var link = e.target.closest && e.target.closest("a[href]");
    if (!link || !results.contains(link)) return;
    if (link.target && link.target !== "" && link.target !== "_self") return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (err) {
      return;
    }
    if (url.origin !== window.location.origin) return;

    e.preventDefault();
    navigate(url.pathname + url.search);
  });

  window.addEventListener("popstate", function () {
    fetchAndSwap(window.location.pathname + window.location.search, false);
  });

  window.LuzAjaxFacets = { submit: submit, navigate: navigate };
})();
